import { Fragment } from 'react';
import { OrganType } from '@/api/apis/case';
import { CS_CERTIFICATE_TYPE, CS_PROCTOR_SHADOW_TITLE, ORGAN_ICON } from '@/utils/helpers';

type CertificateOrgansProps = {
  type: CS_CERTIFICATE_TYPE;
  organs?: OrganType[];
};

export const CertificateOrgans = ({ type, organs }: CertificateOrgansProps) => {
  if (!organs?.length) return null;

  const renderOrgans = (organList: OrganType[] | null) => {
    return Array.from(new Set(organList)).map((o) => {
      const OrganIcon = ORGAN_ICON[o] ?? Fragment;
      return <OrganIcon key={o} className="text-base-5 size-4" />;
    });
  };

  return (
    <div className="flex gap-0.5 max-w-fit items-center ms-1 px-1 bg-base-70 rounded-lg min-h-4">
      <span className="text-s-r text-base-5">{CS_PROCTOR_SHADOW_TITLE[type]}</span>
      {renderOrgans(organs)}
    </div>
  );
};
